import { AlertTriangle, RotateCw } from "lucide-react";
import { cn } from "@/lib/cn";

interface ErrorStateProps {
  title: string;
  description?: string;
  retryLabel?: string;
  onRetry?: () => void;
  className?: string;
}

export const ErrorState = ({
  title,
  description,
  retryLabel,
  onRetry,
  className,
}: ErrorStateProps) => (
  <div
    data-testid="error-state"
    className={cn(
      "flex flex-col items-start gap-3 rounded-sm border border-destructive/30 bg-destructive/5 p-5",
      className,
    )}
  >
    <div className="flex items-start gap-3">
      <AlertTriangle className="mt-0.5 h-5 w-5 text-destructive" />
      <div>
        <p className="text-sm font-semibold text-foreground">{title}</p>
        {description && (
          <p className="mt-1 text-sm text-muted-foreground">{description}</p>
        )}
      </div>
    </div>
    {onRetry && (
      <button
        type="button"
        data-testid="error-state-retry"
        onClick={onRetry}
        className="ops-focus inline-flex items-center gap-2 rounded-sm border border-border bg-card px-3 py-1.5 text-sm font-medium transition-colors duration-150 hover:bg-[hsl(var(--surface-raised))]"
      >
        <RotateCw className="h-3.5 w-3.5" />
        {retryLabel}
      </button>
    )}
  </div>
);
